import { MesfModal } from "@dexteel/mesf-core";
import {
	Button,
	Grid2 as Grid,
	Paper,
	TextField,
	Theme,
	Typography,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import { DelayByShift } from "../models/DelayByShift";

interface Props {
	delay: DelayByShift | null;
	onHide: () => void;
	open: boolean;
}

const useStyles = makeStyles((theme: Theme) => ({
	textField: {
		"& .MuiOutlinedInput-input": {
			height: "60px !important",
		},
	},
}));
export const UpsetConditionModal = ({ delay, onHide, open }: Props) => {
	const classes = useStyles();
	return (
		<>
			<MesfModal
				open={open}
				handleClose={onHide}
				id="upset-condition-modal"
				title="Upset Conditions"
				maxWidth="md"
			>
				<MesfModal.Content>
					<Grid container spacing={2}>
						<Grid size={{ xs: 12 }}>
							<TextField
								variant="outlined"
								fullWidth
								size="small"
								label="What"
								value={delay?.WhatDescription}
								disabled
								multiline
								className={classes.textField}
							/>
						</Grid>
						<Grid size={{ xs: 12 }}>
							<TextField
								variant="outlined"
								fullWidth
								size="small"
								multiline
								label="Why"
								value={delay?.WhyDescription}
								disabled
								className={classes.textField}
							/>
						</Grid>
						<Grid size={{ xs: 12 }}>
							<TextField
								variant="outlined"
								fullWidth
								size="small"
								multiline
								label="Solution"
								value={delay?.SolutionDescription}
								disabled
								className={classes.textField}
							/>
						</Grid>
					</Grid>
				</MesfModal.Content>
				<MesfModal.Actions>
					<Grid container spacing={2} justifyContent="flex-end">
						<Grid size={{ xs: 3, md: 3 }} style={{ margin: 0 }}>
							<Button
								fullWidth
								variant="contained"
								color="primary"
								onClick={onHide}
								size="small"
							>
								Close
							</Button>
						</Grid>
					</Grid>
				</MesfModal.Actions>
			</MesfModal>
		</>
	);
};
